module.exports = __webpack_public_path__ + "img/DK61126228.d4ecc846.png";